/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import { ConvertDatesToStrings } from '@itk/typescript-utils'
import type { Shared_SystemSettings } from '../models/Shared_SystemSettings';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class SystemSettingService {
    /**
     * @param id
     * @returns string Success
     * @throws ApiError
     */
    public static getApiV1SystemSettingsValue(
        id: ConvertDatesToStrings<Shared_SystemSettings>,
    ): CancelablePromise<string> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/systemSettings/{id}/value',
            path: {
                'id': id,
            },
        });
    }
}
